<template>
  <div id="importFromFileWrapper">
    <uploader
      v-if="!file"
      :auto="true"
      label="Selecteer een Excel-bestand (.xlsx)"
      action="files/upload"
    >
    </uploader>

    <template v-else>
      <label class="label">Selecteer de kolommen waar de data geimporteerd moet worden</label>

      <div
        v-for="(column, index) in file.columns"
        :key="index"
        class="field has-addons">

        <div class="control">
          <a class="button is-static">
            <strong>{{ alphabet[index].toUpperCase() }}1</strong>{{ (column) ? '&nbsp;|&nbsp;' + column : '' }}
          </a>
        </div>

        <div class="control is-expanded">
          <div class="select is-fullwidth">
            <select v-model="mapping[index]">
              <option :value="null">-- niet importeren --</option>

              <option
                v-for="column in columns"
                :key="column.column.id"
                :value="column.column.id">
                {{ column.column.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Importeren vanaf regel</label>
        <div class="control">
          <input class="input" type="number" v-model="from">
        </div>
      </div>

      <div class="field">
        <label class="label">Importeren tot en met regel</label>
        <div class="control">
          <input class="input" type="number" v-model="to">
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from '../modules/Uploader'

export default {
  name: 'ImportFromFile',
  components: {
    Uploader
  },
  data () {
    return {
      from: 1,
      to: null,
      mapping: null
    }
  },
  watch: {
    file () {
      if (this.file) {
        this.mapping = this.file.columns.map(column => {
          return (column !== null ) ? null : null
        })
      }

      this.$emit('importfromfile:changed', { key: 'from', value: this.file.file })
    },
    from () {
      this.$emit('importfromfile:changed', { key: 'rows', value: { to: this.to, from: this.from } })
    },
    to () {
      this.$emit('importfromfile:changed', { key: 'rows', value: { to: this.to, from: this.from } })
    },
    mapping () {
      this.$emit('importfromfile:changed', { key: 'mapping', value: this.mapping })
    }
  },
  computed: {
    ...mapGetters({
      file: 'files/file',
      table: 'tables/table',
      columns: 'columns/columns'
    }),
    alphabet () {
      return 'abcdefghijklmnopqrstuvwxyz'.split('')
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('datasets/runImport', {
        dryRun: true,
        from: this.file.file,
        tableId: this.$route.params.tableId,
        to: this.$route.params.bundleId,
        rows: {
          from: this.from,
          to: (this.to === '' || this.to === 0) ? null : this.to
        },
        mapping: this.mapping.map((column, index) => {
          if (column) {
            return {
              columnIdx: index,
              columnId: column
            }
          }
        }).filter(column => column)
      })

      this.$emit('select', {
        file: this.file.file,
        mapping: this.mapping.map((column, index) => {
          if (column) {
            return {
              columnIdx: index,
              columnId: column
            }
          }
        }).filter(column => column),
        rows: {
          from: this.from,
          to: this.to
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
